import {
  Component,
  OnDestroy,
  OnInit,
  ViewChild,
  TemplateRef,
  ElementRef,
  QueryList,
  ViewChildren
} from "@angular/core";
//import { HeaderComponent } from "../header/header.component";
import { BackheaderComponent } from "../backheader/backheader.component";
import { FooterComponent } from "../footer/footer.component";
import { Router, ActivatedRoute } from "@angular/router";
import * as moment from "moment";
import { ToastrService } from "ngx-toastr";
import { Socket } from "ngx-socket-io";
import { UsersService } from "../services/users.service";
import { Subject } from "rxjs";
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { json } from "express";

@Component({
  selector: "app-tabgames",
  templateUrl: "./tabgames.component.html",
  styleUrls: ["./tabgames.component.scss"],
  providers: [BackheaderComponent, FooterComponent],
})
export class TabgamesComponent implements OnInit, OnDestroy {
  offer_data: any;
  banner_img: any;
  homeData: any;
  dataLength: number;
  cricketData: any;
  soccerData: any;
  tennisData: any;
  kabbadiData: any;
  tournamentData: any;
  tableTennisData: any;
  volleyballData: any;
  basketballData: any;
  @ViewChild('rulesmodal') rulesmodal!: TemplateRef<any>;
  @ViewChild('providerTabsContainer') providerTabsContainer!: ElementRef;
  @ViewChildren('providerTab') providerTabs!: QueryList<ElementRef>;
  virtualCricketData: any;
  moment: any = moment;
  inplay: any = false;
  selectedSportData: any;
  userDetails: any;
  targetElement: Element;
  tokenCheck: boolean = false;
  avaialablePlayBattle: any;
  avaialableContest: any;
  logo: any;
  sub: any;
  id: any;
  ids: any;
  idgames: any;
  aviatorArr: any;
  aviatorlog: any;
  Contest_menu: any;
  virtuallog: boolean = false;
  Playerbattle_menu: any;
  kabaddi_menu: any;
  tabletennis_menu: any;
  volleyball_menu: any;
  basketball_menu: any;
  gapcasino_menu: any;
  ballArr: any;
  ballbycricket: any;
  modalRefcancel: BsModalRef;
  modalrules: BsModalRef;
  casino_type: string = 'LIVECASINO';
  casino_data: any;
  res_msg: any;
  ContestList: any[] = [];
  ContestPlayerList: any[] = [];
  activeTab: any = 'all';
  activePlayerTab: any = 'allc';
  rulmodaltab: any = 'eng';
  tabss: any;
  edsid: any;
  loading = false;
  Horsetabs: any[] = [];
  casinoProviders: any[] = [];
  selectedProvider = '';
  providerGames: any[] = [];
  casinodatgap: any[] = [];
  Base_Url: "https://adminapi.clubosg.com/uploads/banners/"
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private socket: Socket,
    private usersService: UsersService,
    private modalService: BsModalService,

  ) {
    this.getBanner();
    this.Setupsync();
    this.sub = this.route.params.subscribe(params => {

      const routeId = params['id'];

      this.id = String(routeId || '')
        .split('?')[0]
        .trim();

      // console.log('TABGAMES ID:', this.id);

      if (this.id === '11') {
        this.onTournamentClick();
      }
      else if (
        this.id === '10' ||
        this.id === '12'
      ) {
        this.getHorseEvent(this.id);
      }

      this.ids = JSON.stringify(this.id);
    });
    // console.log(this.ids);

    this.route.params.subscribe((params) => {
      if (params.sportName === undefined) {
        if (sessionStorage.getItem("loginStatus") === "true") {
          this.homeSoc('none');
          this.settings();

        } else {
          this.homeSoc('none');
          //this.homeFreeSoc();
          this.tokenCheck = true;
        }
      } else if (
        params.sportName === "inplay" &&
        sessionStorage.getItem("loginStatus") === "true"
      ) {
        this.Inplay();
        this.inplay = true;
        this.settings();

      }
    });


  }


  async getDetials() {
    try {
      const data = await JSON.parse(sessionStorage.getItem("userDetails"));

      return data;
    } catch (e) {
      return null;
    }
  }

  home() {
    this.router.navigate(["home"]);
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe(params => {
      const urlProvider =
        params['provider'];

      const savedProvider =
        sessionStorage.getItem(
          'selectedCasinoProvider'
        );

      this.selectedProvider =
        String(
          urlProvider ||
          savedProvider ||
          'EZUGI'
        )
          .trim()
          .toUpperCase();
      this.casino_gap();
    });

    document.addEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );

    this.targetElement =
      document.querySelector('html');

    this.SetactiveTab('all');
    this.SetPlayeractiveTab('allc');
  }

  async Setupsync() {
    this.userDetails = await this.getDetials();
    if (this.userDetails?.detail?._id) {
      const data = { user_id: this.userDetails?.details?._id };
      // console.log(data);
      this.get(data);

    }
  }

  public cricket(section: string) {
    window.location.hash = '';
    window.location.hash = section;
    // console.log(section);

  }

  openDialog2(myModal: TemplateRef<any>) {
    localStorage.setItem('firstVisit', 'result');
    this.modalrules = this.modalService.show(
      myModal,
      Object.assign({}, { class: 'success modal-lg' })
    );
  }


  myRefreshEvent(event: Subject<any>, message: string) {
    setTimeout(() => {
      alert(message);
      event.next();
    }, 3000);
  }

  alert(message: string) {
    alert(message);
  }

  async settings() {
    this.userDetails = await this.getDetials();

    const data = { user_id: this.userDetails.details._id };
    this.usersService.SocketPost("menusetting", data).subscribe((res: any) => {
      var available_events = res;
      if (available_events) {
        // this.wallet_status=available_events?.manager?.wallet_status;
        var available_event = available_events.eventTypes;
        const available_user = available_events.user.availableEventTypes;

        // Map event types to menu variables
        const eventMap = {
          '1': 'soccer_menu',
          '2': 'tennis_menu',
          '4': 'cricket_menu',
          'c9': 'casino_menu',
          'aviator': 'aviatorlog',
          'e9': 'election_menu',
          '4339': 'grayhond_menu',
          '7': 'horse_menu',
          'd1': 'diamond_menu',
          '27979456': 'kabaddi_menu',
          '3902': 'Contest_menu',
          '3901': 'Playerbattle_menu',
          '8': 'tabletennis_menu',
          '18': 'volleyball_menu',
          '15': 'basketball_menu',
          'g9': 'gapcasino_menu',
        };

        // Initialize menu visibility
        Object.keys(eventMap).forEach((id) => {
          const menuKey = eventMap[id];
          const isEventAvailable = available_user.includes(id);
          const event = available_event.find((data) => data.eventType.id === id);
          // console.log(isEventAvailable);
          this[menuKey] = event?.visible_status && isEventAvailable;

        });
      }
    });
  }
  async Inplay() {

    this.userDetails = await this.getDetials();
    const data = { user_id: this.userDetails.details._id };
    this.usersService.SocketPost("get-inplay-markets", data).subscribe((res: any) => {
      if (res) {
        // sessionStorage.setItem(cacheKey3,JSON.stringify({ inplayMarkets: res, timestamp: Date.now() }));
        // console.log(res.data);
        this.dataLength = res.data?.length;
        this.cricketData = [];
        this.soccerData = [];
        this.tennisData = [];
        this.kabbadiData = [];
        this.tableTennisData = [];
        this.volleyballData = [];
        this.basketballData = [];
        for (let i = 0; i < res.data?.length; i++) {
          const sortInplayFirst = (
            a: { marketBook: { inplay: boolean } },
            b: { marketBook: { inplay: boolean } }
          ) => {
            if (a.marketBook?.inplay === b.marketBook?.inplay) return 0;
            return a.marketBook?.inplay ? -1 : 1; // true first
          };

          if (res.data[i].eventTypeId == 4) {
            this.cricketData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🏏 Cricket Data:', this.cricketData);
          } else if (res.data[i].eventTypeId == 1) {
            this.soccerData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('⚽ Soccer Data:', this.soccerData);
          } else if (res.data[i].eventTypeId == 2) {
            this.tennisData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🎾 Tennis Data:', this.tennisData);
          }
          else if (res.data[i].eventTypeId == 27979456) {
            this.kabbadiData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🎾 kabbadiData:', this.kabbadiData);
          }
          else if (res.data[i].eventTypeId == 8) {
            this.tableTennisData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🎾 Tennis Data:', this.tennisData);
          }
          else if (res.data[i].eventTypeId == 18) {
            this.volleyballData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🎾 Tennis Data:', this.tennisData);
          }
          else if (res.data[i].eventTypeId == 15) {
            this.basketballData = res.data[i].markets.sort(sortInplayFirst);
            // console.log('🎾 Tennis Data:', this.tennisData);
          }
        }
      }
      else {
        this.toastr.error(res.message, 'Error!');
      }
    });

    // this.checkVirtualShow();
  }

  // checkVirtualShow() {
  //   if (
  //     this.virtualCricketData?.length &&
  //     this.virtualCricketData[0]?.managerStatus[
  //       this.userDetails.details.manager
  //     ] === true
  //   ) {
  //     return true;
  //   } else {
  //     return false;
  //   }
  // }

  async onTournamentClick() {

    this.userDetails = await this.getDetials();
    const data = { user_id: this.userDetails.details._id };
    this.usersService.SocketPost("get-market-tournament-eventTypeWise", data).subscribe((res: any) => {
      if (res) {
        // sessionStorage.setItem(cacheKey3,JSON.stringify({ inplayMarkets: res, timestamp: Date.now() }));
        // console.log(res.data);
        this.dataLength = res.data?.length;
        this.tournamentData = [];
        for (let i = 0; i < res.data?.length; i++) {
          const sortInplayFirst = (
            a: { marketBook: { inplay: boolean } },
            b: { marketBook: { inplay: boolean } }
          ) => {
            if (a.marketBook?.inplay === b.marketBook?.inplay) return 0;
            return a.marketBook?.inplay ? -1 : 1; // true first
          };

          if (res.data[i].eventTypeId == 4) {
            this.tournamentData = res.data[i].markets.sort(sortInplayFirst);

          }
        }
      }
      else {
        this.toastr.error(res.message, 'Error!');
      }
    });

    // this.checkVirtualShow();
  }
  getHorseEvent(id: any) {
    // 🔄 start loading
    this.loading = true;
    this.Horsetabs = [];

    if (id == "10") {
      this.edsid = '7';
    } else if (id == "12") {
      this.edsid = '4339';
    }

    const data = {
      eventTypeId: this.edsid,
    };

    this.usersService.SocketPost('anotherSports', data).subscribe(
      (res: any) => {
        this.tabss = res?.marketcountryCode;
        this.Horsetabs = res?.data || [];
        this.loading = false;
      },
      (error) => {
        this.loading = false;
        this.Horsetabs = [];
      }
    );
  }
  async homeSoc(id: any) {
    const cachedData = sessionStorage.getItem("cacheKey");

    if (cachedData) {
      const { markets, timestampB } = JSON.parse(cachedData);
      // Check if cache is still valid (5 minutes = 300,000 ms)
      if (Date.now() - timestampB < 60 * 1000) {
        this.processResponse(markets);
        return; // Use cached message
      } else {
        sessionStorage.removeItem('cacheKey'); // Clear expired cache
      }
    }

    // API call if no valid cache found
    const timestampMs = Date.now();
    const timestamp = 198728782826 * timestampMs;
    this.userDetails = await this.getDetials();
    let data
    if (this.userDetails == null) {
      data = {};
    } else {
      data = {
        user_id: this.userDetails.details._id,
        timestamp: timestamp,
        // ...(id !== "none" && { eventTypeId: id }) // Add eventTypeId only if provided
      };
    }

    this.usersService.SocketPost("get-market-eventTypeWise", data).subscribe((res: any) => {
      if (res) {
        var markets = res;
        // Save message to localStorage with timestamp
        sessionStorage.setItem("cacheKey", JSON.stringify({ markets: markets, timestampB: Date.now() }));
        this.processResponse(markets);
      }
    });
  }

  // Separate function to process and store response data
  processResponse(res) {
    this.dataLength = res.data.length;

    for (let i = 0; i < res.data.length; i++) {
      const sortInplayFirst = (
        a: { marketBook: { inplay: boolean } },
        b: { marketBook: { inplay: boolean } }
      ) => {
        if (a.marketBook?.inplay === b.marketBook?.inplay) return 0;
        return a.marketBook?.inplay ? -1 : 1;
      };

      const event = res.data[i];

      if (event.eventTypeId == 4) {
        this.cricketData = event.markets.sort(sortInplayFirst);
        //  console.log('🏏 Cricket Data:', this.cricketData);
      } else if (event.eventTypeId == 1) {
        this.soccerData = event.markets.sort(sortInplayFirst);
        // console.log('⚽ Soccer Data:', this.soccerData);
      } else if (event.eventTypeId == 2) {
        this.tennisData = event.markets.sort(sortInplayFirst);
        // console.log('🎾 Tennis Data:', this.tennisData);
      }
      else if (event.eventTypeId == 27979456) {
        this.kabbadiData = event.markets.sort(sortInplayFirst);
        // console.log('kabbadi Data:', this.kabbadiData);
      }
      else if (event.eventTypeId == 8) {
        this.tableTennisData = event.markets.sort(sortInplayFirst);
        // console.log('🎾 Tennis Data:', this.tennisData);
      }
      else if (event.eventTypeId == 18) {
        this.volleyballData = event.markets.sort(sortInplayFirst);
        // console.log('🎾 Tennis Data:', this.tennisData);
      }
      else if (event.eventTypeId == 15) {
        this.basketballData = event.markets.sort(sortInplayFirst);
        // console.log('🎾 Tennis Data:', this.tennisData);
      }
    }
  }

  async findHostName() {
    return window.location.hostname;
  }

  async getHost() {
    const hostname = await this.findHostName();
    const splithostname = hostname.split(".");
    this.logo = splithostname[0];
    this.setManager(splithostname[0]);
  }

  setManager(hostname: any) {
    if (hostname === "clubprt") {
      this.getOffer("PRTCLUB");
    } else if (hostname === "ferrariclubb") {
      this.getOffer("FERRARICLUB");
    } else if (hostname === "clubaob") {
      this.getOffer("AOBCLUB");
    } else if (hostname === "dlexch") {
      this.getOffer("DLCLUB");
    } else if (hostname === "fairbets247") {
      this.getOffer("FAIRBET");
    } else if (hostname === "clubosg") {
      this.getOffer("");
    } else if (hostname === "clubosg" || hostname === "dubaiclub247") {
      this.getOffer("OSGCLUB");
    } else if (hostname === "clublucky7") {
      this.getOffer("PRTLUCKY");
    }
  }

  getBanner() {
    this.getHost();
    this.usersService.Get("get-banner/").subscribe((response: any) => {


      this.banner_img = [];
      if (response.error) {
        this.toastr.error(response.message, "Error!");
      } else {
        this.banner_img = response.response;
      }
    });
  }

  getOffer(manager_name) {
    const data = { filter: { manager: manager_name, visible: true } };
    this.usersService
      .post_api("get-offer/", data)
      .subscribe((response: any) => {
        this.offer_data = [];
        if (response.error) {
          this.toastr.error(response.message, "Error!");
        } else {
          this.offer_data = response.data;
        }
      });
  }



  getUserBalance() {
    const userdata = {
      user: {
        _id: this.userDetails._id,
        key: this.userDetails.key,
        token: this.userDetails.verifytoken,
        details: {
          username: this.userDetails.details.username,
          role: this.userDetails.details.role,
          status: this.userDetails.details.status,
        },
      },
    };

    this.socket.emit("get-user", userdata);

    this.socket.on(
      "get-user-success",
      function (data: any) {
        if (data) {
          this.usersService.updateUserBalanceSubject(data);
        }
      }.bind(this)
    );
  }

  goToDashboard(sportName, id, data) {
    if (id == -100) {
      this.router.navigate(["casino"]);
    } else if (id < -100) {
      this.router.navigate([
        "snova/" + id + "/" + data.name + "/" + data.providerCode,
      ]);
    } else {
      this.router.navigate(["dashboard/" + sportName]);
    }
  }

  checkInplayStatus(value): boolean {
    let CurrentDate = new Date();
    const currDate = CurrentDate.toISOString();
    if (currDate > value) {
      return true;
    } else {
      return false;
    }
  }

  checkTodayStatus(value): boolean {
    let CurrentDate = new Date();
    const currDate = CurrentDate.toISOString();
    let getdate = this.moment(value).format('DD MMMM YYYY');
    let today = this.moment(CurrentDate).format('DD MMMM YYYY');
    if (today == getdate) {
      return true;
    } else {
      return false;
    }
  }
  checkTomorrowStatus(value): boolean {
    let CurrentDate = new Date();
    const currDate = CurrentDate.toISOString();
    let getdate = this.moment(value).startOf('day'); // Ensure only the date part is considered
    let tomorrow = this.moment(CurrentDate).add(1, 'days').startOf('day'); // Tomorrow
    let dayAfterTomorrow = this.moment(CurrentDate).add(2, 'days').startOf('day');
    // console.log(getdate);
    if (getdate.isSame(tomorrow)) {
      // console.log('The date is tomorrow.');
      return true;
    } else if (getdate.isSame(dayAfterTomorrow)) {
      // console.log('The date is the day after tomorrow.');
      return true;
    } else if (getdate.isAfter(dayAfterTomorrow)) {
      // console.log('The date is after the day after tomorrow.');
      return true;
    } else {
      // console.log('The date is before tomorrow.');
      return false;
    }
    // let getdate = this.moment(value).format('DD MMMM YYYY');
    // let tomorrow = this.moment(CurrentDate).add(1, 'days').format('DD MMMM YYYY').toString();;
    // if (tomorrow <= getdate) {
    //   return true;
    // } else {
    //   return false;
    // }
  }

  openCasino(gameID: string) {

    const data = { gameId: gameID };
    localStorage.setItem('casinoDb', JSON.stringify(data));
    // this.route.navigate(['./casino-url']);
    this.router.navigate(["./casino-url"]);

  }
  casino_games(type: string) {
    this.casino_type = type;
    const data = {
      gametype: type,
      username: this.userDetails?.details?.username,
    };
    this.usersService.casioPost('providerGames', data).subscribe((res: any) => {
      // console.log(res);

      if (res.error) {
        this.res_msg = res.message;
        // console.log(this.res_msg);
      }
      else {
        this.casino_data = [];
        this.casino_data = res?.data?.items;
        // console.log(this.casino_data);
      }
    });

  }

  opengapss(gameID: string): void {
    // console.log('OPEN CASINO GAME ID:', gameID);

    if (!gameID) {
      console.error('Game ID is missing');
      return;
    }

    const data = {
      gameId: String(gameID)
    };

    localStorage.setItem('casinoDb', JSON.stringify(data));

    this.router.navigate(['/casino-gap-url']);
  }
  casino_gap(): void {
    this.usersService
      .SoPost('get-game-list', '')
      .subscribe({

        next: (res: any) => {

          if (res?.error) {

            this.res_msg =
              res?.message ||
              'Unable to load games';

            return;
          }

          let games: any[] = [];

          if (Array.isArray(res?.data)) {

            games =
              res.data;

            //  console.log(games);
          }
          else if (
            Array.isArray(
              res?.data?.items
            )
          ) {

            games =
              res.data.items;

          }
          else if (
            Array.isArray(
              res?.items
            )
          ) {

            games =
              res.items;

          }
          else if (
            Array.isArray(res)
          ) {

            games =
              res;

          }

          if (!games.length) {
            this.casinodatgap = [];
            this.casinoProviders = [];
            this.providerGames = [];

            return;
          }

          /*
           * Keep full data only in memory.
           * DO NOT put this in sessionStorage.
           */

          this.casinodatgap =
            games;

          const providerMap =
            new Map<string, any>();

          games.forEach(
            (game: any) => {

              if (!game) {
                return;
              }

              let providerName = '';

              if (
                game?.providerName
              ) {

                providerName =
                  String(
                    game.providerName
                  ).trim();

              }

              if (
                !providerName &&
                game?.subProviderName
              ) {

                providerName =
                  String(
                    game.subProviderName
                  ).trim();

              }

              if (!providerName) {
                return;
              }

              const key =
                providerName
                  .toUpperCase();

              if (
                !providerMap.has(key)
              ) {

                providerMap.set(
                  key,
                  {
                    name:
                      providerName,
                    games: []
                  }
                );

              }

              providerMap
                .get(key)
                .games
                .push(game);

            }
          );

          this.casinoProviders =
            Array.from(
              providerMap.values()
            );
          const requestedProvider =
            String(
              this.selectedProvider ||
              'EZUGI'
            )
              .trim()
              .toUpperCase();

          let selectedProvider =
            this.casinoProviders.find(
              (provider: any) =>
                String(
                  provider?.name || ''
                )
                  .trim()
                  .toUpperCase() ===
                requestedProvider
            );

          /*
           * Requested provider
           * nahi mila to EZUGI.
           */

          if (!selectedProvider) {

            selectedProvider =
              this.casinoProviders.find(
                (provider: any) =>
                  String(
                    provider?.name || ''
                  )
                    .trim()
                    .toUpperCase() ===
                  'EZUGI'
              );

          }

          /*
           * EZUGI bhi nahi mila
           * to first provider.
           */

          if (!selectedProvider) {

            selectedProvider =
              this.casinoProviders[0];

          }

          if (selectedProvider) {

            this.selectedProvider =
              String(
                selectedProvider.name
              ).trim();

            this.providerGames =
              Array.isArray(
                selectedProvider.games
              )
                ? selectedProvider.games
                : [];

          }
          else {

            this.selectedProvider =
              '';

            this.providerGames =
              [];

          }

          try {

            sessionStorage.setItem(
              'selectedCasinoProvider',
              this.selectedProvider
            );

          }
          catch (storageError) {
          }

          setTimeout(() => {

            this.scrollToSelectedProvider();

          }, 100);

        },

        error: (error: any) => {

          console.error(
            'get-game-list ERROR:',
            error
          );

          this.casinodatgap = [];
          this.casinoProviders = [];
          this.providerGames = [];

          this.res_msg =
            error?.error?.message ||
            'Failed to load casino games';

        }

      });
  }
  scrollToSelectedProvider(): void {
    setTimeout(() => {

      const container = this.providerTabsContainer?.nativeElement;

      if (!container) {
        return;
      }

      const selectedIndex = this.casinoProviders.findIndex(
        (provider: any) =>
          provider?.name?.trim().toUpperCase() ===
          this.selectedProvider?.trim().toUpperCase()
      );

      if (selectedIndex === -1) {
        return;
      }

      const tab = this.providerTabs?.toArray()[selectedIndex]?.nativeElement;

      if (!tab) {
        return;
      }

      const left =
        tab.offsetLeft -
        (container.clientWidth / 2) +
        (tab.offsetWidth / 2);

      container.scrollLeft = left;

    }, 0);
  }

  // ======================================
  // SELECT PROVIDER
  // ======================================

  selectProvider(provider: string): void {

    if (!provider) {
      return;
    }

    const providerName =
      String(provider)
        .trim()
        .toUpperCase();

    const selected =
      this.casinoProviders.find(
        (item: any) =>
          String(item?.name || '')
            .trim()
            .toUpperCase() ===
          providerName
      );

    if (!selected) {
      return;
    }

    this.selectedProvider =
      String(selected.name).trim();

    this.providerGames =
      Array.isArray(selected.games)
        ? selected.games
        : [];
    //console.log(this.providerGames);
    sessionStorage.setItem(
      'selectedCasinoProvider',
      this.selectedProvider
    );

    this.router.navigate(
      ['/tabgames', '6'],
      {
        queryParams: {
          provider: this.selectedProvider
        }
      }
    );

    setTimeout(() => {
      this.scrollToSelectedProvider();
    }, 0);
  }

  handleVisibilityChange = (): void => {
    if (
      document.visibilityState !== 'visible'
    ) {
      return;
    }

    if (
      this.casinoProviders?.length &&
      this.providerGames?.length
    ) {
      return;
    }
    this.casino_gap();
  };

  trackByProvider(
    index: number,
    provider: any
  ): string {

    return provider?.name || index.toString();

  }

  trackByGameId(
    index: number,
    game: any
  ): string | number {

    return game?.gameId || index;

  }
  // selectProvider(provider: string): void {
  //   this.selectedProvider = provider;
  // }



  matchDetail(eventId, eventTypeId) {
    this.router.navigate(["match-detail", eventId, eventTypeId]);
  }

  // virtualDetial(eventId, eventTypeId) {
  //   this.router.navigate(["virtual-detail", eventId, eventTypeId]);
  // }

  get(data: any): void {
    this.usersService.SocketPost('get-contest-markets', data).subscribe(
      (res: any) => {
        this.ContestList = res?.response || [];
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }

  Go(id: string): void {
    this.router.navigate([`/eventcontest`, id]);
  }

  async SetactiveTab(tabname: any) {
    this.userDetails = await this.getDetials();
    this.activeTab = tabname
    if (tabname === 'all') {
      this.ContestList = []
      const data = { user_id: this.userDetails.details._id };
      this.get(data);
    }
    if (tabname === 'joined') {
      this.ContestList = []
      const data = { user_id: this.userDetails.details._id, type: 0 };
      this.getContestDetails(data)
    }
    if (tabname === 'settled') {
      this.ContestList = []
      const data = { user_id: this.userDetails.details._id, type: 1 };
      this.getContestDetails(data)
    }
  }


  getContestDetails(data: any): void {
    this.usersService.SocketPost('get-allcontest-bets', data).subscribe(
      (res: any) => {
        this.ContestList = res?.response || [];
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }

  isOptionSelected(selectionName: string, runnerName: string): boolean {
    if (!selectionName || !runnerName) return false;

    const selectedList = selectionName.split(',').map(name => name.trim());
    return selectedList.includes(runnerName.trim());
  }
  getOptionLabel(index: number): string {
    // Converts 0 -> A, 1 -> B, 2 -> C, 3 -> D ...
    return String.fromCharCode(65 + index);
  }



  // playerbattle code

  async SetPlayeractiveTab(tabname: any) {

    this.userDetails = await this.getDetials();
    this.activePlayerTab = tabname
    if (tabname === 'allc') {
      if (this.userDetails?.details?._id) {
        const data = { user_id: this.userDetails.details._id };
        this.playebattleget(data);
      }
    }
    if (tabname === 'joinedc') {
      if (this.userDetails?.details?._id) {
        const data = {
          filter: { result: "ACTIVE", eventTypeId: "3901", username: this.userDetails.details.username, deleted: false },
          user_id: this.userDetails?.details?._id
        }
        this.getBetsplayer(data)
      }
    }
    if (tabname === 'settledc') {
      if (this.userDetails?.details?._id) {
        const data = {
          filter: { result: { $ne: "ACTIVE" }, eventTypeId: "3901", username: this.userDetails.details.username, deleted: false },
          user_id: this.userDetails?.details?._id
        }
        this.getBetsplayer(data)
      }
    }
  }
  playebattleget(data: any) {
    this.usersService.SocketPost('get-playbattle-markets', data).subscribe(
      (res: any) => {
        if (res.success === true) {
          this.ContestPlayerList = res.response.map((item: any) => ({
            ...item,
            countdownText: ''
          }));
          this.ContestPlayerList.forEach((item: any) => {
            this.startCountdown(item);
          });
        }
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }

  getBetsplayer(data: any) {

    this.usersService.SocketPost('get-playbattle-bet', data).subscribe(
      (res: any) => {
        if (res.success === true) {
          this.ContestPlayerList = res.response.map((item: any) => ({
            ...item,
            countdownText: ''
          }));
          this.ContestPlayerList.forEach((item: any) => {
            this.startCountdown(item);
          });
        }
      },
      (error) => {
        console.error('Error fetching contests:', error);
      }
    );
  }
  formatReadableDate(apiDate: string) {
    const date = new Date(apiDate);

    const options: Intl.DateTimeFormatOptions = {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };

    return date.toLocaleString("en-GB", options).replace(",", "");
  }
  startCountdown(item: any) {
    const target = new Date(item.openDate).getTime();

    setInterval(() => {
      const now = new Date().getTime();
      const diff = target - now;

      if (diff <= 0) {
        item.countdownText = "00D : 00H : 00M : 00S";
        return;
      }

      const days = Math.floor(diff / 86400000);
      const hours = Math.floor((diff % 86400000) / 3600000);
      const mins = Math.floor((diff % 3600000) / 60000);
      const secs = Math.floor((diff % 60000) / 1000);

      item.countdownText = `${days}D : ${hours}H : ${mins}M : ${secs}S`;
    }, 1000);
  }



  GotoEventpage(id: string): void {
    this.router.navigate([`/eventplayerbattle`, id]);
  }
  mergeRunners(item: any) {
    const marketRunners = item?.marketBook?.runners || [];
    const resultRunners = item?.runnerArray || [];
    const selectionName = String(item?.selectionName).trim();
    const userPoint = Number(item?.marketBook?.userPoint) || 0;
    const computerPoint = Number(item?.marketBook?.computerPoint) || 0;
    const merged = marketRunners.map(mr => {
      const rr = resultRunners.find(r => r.selectionId === mr.selectionId);

      return {
        ...mr,
        selected: rr?.selected ?? null,
        runs: rr?.runs ?? 0
      };
    });
    const userTotalRuns = resultRunners.reduce(
      (sum, r) => sum + (Number(r?.selected) === 1 ? Number(r.runs) : 0),
      0
    );

    const computerTotalRuns = resultRunners.reduce(
      (sum, r) => sum + (Number(r?.selected) !== 1 ? Number(r.runs) : 0),
      0
    );


    return {
      mergedRunners: merged,
      userTotalRuns: userTotalRuns + (selectionName === "2" ? userPoint : 0),
      computerTotalRuns: computerTotalRuns + (selectionName === "1" ? computerPoint : 0),
      userPoint: userPoint,
      computerPoint: computerPoint,
      selectionName: selectionName,
    };
  }

  openRules(rulesmodal: TemplateRef<any>) {
    this.modalRefcancel = this.modalService.show(
      rulesmodal,
      Object.assign({}, { class: 'success modal-lg' })
    );
  }
  setrulesmodalTab(tab: string) {
    this.rulmodaltab = tab;
  }

  openMarket1(eventId: any, eventTypeId: any, marketId: any) {
    // console.log(eventId, eventTypeId);
    this.router.navigate(['match-detail/', eventId, eventTypeId, marketId]);
  }
  //end playebattle
  onClickofSport(sport) {
    this.selectedSportData = sport;
  }

  goToInplay(sportName) {
    this.router.navigate(["dashboard/" + sportName]);
  }


  ngOnDestroy(): void {

    document.removeEventListener(
      'visibilitychange',
      this.handleVisibilityChange
    );

    if (this.sub) {
      this.sub.unsubscribe();
    }
  }
}
